"use client";

import LottieView from "lottie-react";

import LottieFile from "../../public/animations/404.json";

function NotFound() {
  return (
    <div className="flex flex-col w-screen h-screen items-center justify-center absolute bg-white dark:bg-background left-0 top-0">
      <LottieView
        animationData={LottieFile}
        loop
        className="md:w-[24%] h-[40%]"
      />

      <p className=" text-primary-1 font-bold text-3xl tracking-wide">Oops!</p>
      <p className="text-grey-1 font-bold text-lg tracking-wide text-center">
        Sorry! The page you’re looking for cannot be found
      </p>
    </div>
  );
}

export default NotFound;
